// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/components/routes/Forms/Qrcode/Qrcode.css */

.qr_headi{
    text-align: center;
    font-size: 1.5rem;
    font-weight: 600;
    color: white;
    margin-top: 2rem;
    margin-bottom: 2rem;
}

.qr_headi:hover {
    color: #EF6F53;
}
  
.qr-code-block{
    background-color: #EF6F53; 
    color: white; 
    border: none; 
    border-radius: 5px; 
    padding: 10px 15px; 
    font-size: 1rem; 
    cursor: pointer; 
    text-align: center; 
    margin: auto;
    margin-top: 1rem;

}

.qr-code-block:hover{
    background-color: #ff4800;
    transition: 0.3s;
}

.error-message{
    color: white;
    margin-top: 1rem;
    font-size: 1rem;
    font-weight: 100;
}

.qr-instruction, .loading-msg{
    color: white;
    margin-top: 3rem;
    font-size: 1rem;
    font-weight: 600;
}

.success-message {
    color: #EF6F53;
    margin: auto;
    margin-top: 1rem;
    text-align: center;
    animation: fadeIn 0.5s ease-in;
    font-weight: 600;
    font-size: 1.2rem;
}

.success-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 20px;
}

.continue-button {
    background-color: #EF6F53; 
    color: white; 
    border: none; 
    border-radius: 5px; 
    padding: 10px 15px; 
    font-size: 1rem; 
    cursor: pointer; 
    text-align: center; 
    margin: auto;
    margin-top: 4rem;
    transition: background-color 0.3s ease;
}

.continue-button:hover {
    background-color: #ff4800;
}

.reset-button{
    background-color: #EF6F53; 
    color: white; 
    border: none; 
    border-radius: 5px; 
    padding: 10px 15px; 
    font-size: 1rem; 
    cursor: pointer; 
    text-align: center; 
    margin: auto;
    margin-top: 2rem;
    transition: background-color 0.3s ease;

}

.reset-button:hover {
    background-color: #ff4800;
}

.loading-message{
    color: white;
}

@keyframes fadeIn {
    from {
        opacity: 0;
        transform: translateY(-10px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}`, "",{"version":3,"sources":["webpack://./src/components/routes/Forms/Qrcode/Qrcode.css"],"names":[],"mappings":"AAAA,kDAAkD;;AAElD;IACI,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,YAAY;IACZ,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,kBAAkB;IAClB,YAAY;IACZ,gBAAgB;;AAEpB;;AAEA;IACI,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,8BAA8B;IAC9B,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,kBAAkB;IAClB,YAAY;IACZ,gBAAgB;IAChB,sCAAsC;AAC1C;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,kBAAkB;IAClB,YAAY;IACZ,gBAAgB;IAChB,sCAAsC;;AAE1C;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI;QACI,UAAU;QACV,4BAA4B;IAChC;IACA;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ","sourcesContent":["/* src/components/routes/Forms/Qrcode/Qrcode.css */\n\n.qr_headi{\n    text-align: center;\n    font-size: 1.5rem;\n    font-weight: 600;\n    color: white;\n    margin-top: 2rem;\n    margin-bottom: 2rem;\n}\n\n.qr_headi:hover {\n    color: #EF6F53;\n}\n  \n.qr-code-block{\n    background-color: #EF6F53; \n    color: white; \n    border: none; \n    border-radius: 5px; \n    padding: 10px 15px; \n    font-size: 1rem; \n    cursor: pointer; \n    text-align: center; \n    margin: auto;\n    margin-top: 1rem;\n\n}\n\n.qr-code-block:hover{\n    background-color: #ff4800;\n    transition: 0.3s;\n}\n\n.error-message{\n    color: white;\n    margin-top: 1rem;\n    font-size: 1rem;\n    font-weight: 100;\n}\n\n.qr-instruction, .loading-msg{\n    color: white;\n    margin-top: 3rem;\n    font-size: 1rem;\n    font-weight: 600;\n}\n\n.success-message {\n    color: #EF6F53;\n    margin: auto;\n    margin-top: 1rem;\n    text-align: center;\n    animation: fadeIn 0.5s ease-in;\n    font-weight: 600;\n    font-size: 1.2rem;\n}\n\n.success-container {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 20px;\n}\n\n.continue-button {\n    background-color: #EF6F53; \n    color: white; \n    border: none; \n    border-radius: 5px; \n    padding: 10px 15px; \n    font-size: 1rem; \n    cursor: pointer; \n    text-align: center; \n    margin: auto;\n    margin-top: 4rem;\n    transition: background-color 0.3s ease;\n}\n\n.continue-button:hover {\n    background-color: #ff4800;\n}\n\n.reset-button{\n    background-color: #EF6F53; \n    color: white; \n    border: none; \n    border-radius: 5px; \n    padding: 10px 15px; \n    font-size: 1rem; \n    cursor: pointer; \n    text-align: center; \n    margin: auto;\n    margin-top: 2rem;\n    transition: background-color 0.3s ease;\n\n}\n\n.reset-button:hover {\n    background-color: #ff4800;\n}\n\n.loading-message{\n    color: white;\n}\n\n@keyframes fadeIn {\n    from {\n        opacity: 0;\n        transform: translateY(-10px);\n    }\n    to {\n        opacity: 1;\n        transform: translateY(0);\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
